import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { SlideToConfirm } from "@/components/ui/slide-to-confirm";

type Props = {
  open: boolean;
  kbName: string;
  onClose: () => void;
  onConfirm: () => void;
  isPending: boolean;
};

export const StopAllDialog = ({
  open,
  kbName,
  onClose,
  onConfirm,
  isPending,
}: Props) => (
  <Dialog
    open={open}
    onOpenChange={(o) => {
      if (!o) onClose();
    }}
  >
    <DialogContent className="sm:max-w-md">
      <DialogHeader>
        <DialogTitle>Stop all analyzing</DialogTitle>
      </DialogHeader>

      <p className="text-sm text-muted-foreground">
        Stop analyzing every in-progress document in{" "}
        <span className="font-medium text-foreground">{kbName}</span>? They
        return to the uploaded state and can be analyzed again.
      </p>

      <SlideToConfirm
        label={isPending ? "Stopping…" : "Slide to confirm"}
        onConfirm={onConfirm}
        isDanger
        className="mt-2"
      />
    </DialogContent>
  </Dialog>
);
